// import Account from './pages/login/Acc.jsx'
import HomePage from './pages/Home/HomePage.jsx';
import Account from './pages/login/Acc.jsx';

import { Analytics } from "@vercel/analytics/react"

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Nav from './components/Nav/nav.jsx';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Info from './pages/MovieOrTvDetails/info.jsx';
import Upcoming from './pages/upcoming/Upcoming.jsx';
import OnlyMovies from './pages/Movies/OnlyMovies.jsx';
import OnlyTv from './pages/Tv Shows/OnlyTv.jsx';

function App() {

  return (
    <BrowserRouter>
      <Analytics />
      <Nav></Nav>
      <Routes>
        <Route path='/' element={<HomePage />}></Route>
        <Route path='/:id' element={<Info />}></Route>
        <Route path='/Upcoming' element={<Upcoming />}></Route>
        <Route path='/Account' element={<Account />}></Route>
        <Route path='/TvShows' element={<OnlyTv />}></Route>
        <Route path='/Movies' element={<OnlyMovies />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
